import { store } from 'Store/store.index'
import { GA_FOR_SHAREPOINT } from '../GoogleAnalyticsMap/SharePointGAMap'

export default class SharePointGASender {
  constructor() {}
  getTargetDrive() {
    const { isFromSharePoint, fromDrive } = store.appStore.sharePointInfo

    if (!isFromSharePoint) {
      return null
    }
    
    const targetDrive = fromDrive || 'SharePoint'

    return targetDrive
  }
  signInPopUp() {
    const targetDrive = this.getTargetDrive()

    if (targetDrive === null) {
      return
    }

    const params = GA_FOR_SHAREPOINT.signInPopUp[targetDrive]

    store.userStore.doSendGAEvent(params)
  }
  signInSuccessful() {
    const targetDrive = this.getTargetDrive()

    if (targetDrive === null) {
      return
    }

    const params = GA_FOR_SHAREPOINT.signInSuccessful[targetDrive]

    store.userStore.doSendGAEvent(params)
  }
  signInInterrupted() {
    const targetDrive = this.getTargetDrive()

    if (targetDrive === null) {
      return
    }

    const params = GA_FOR_SHAREPOINT.signInInterrupted[targetDrive]

    store.userStore.doSendGAEvent(params)
  }
  signUpPopUp() {
    const targetDrive = this.getTargetDrive()

    if (targetDrive === null) {
      return
    }

    const params = GA_FOR_SHAREPOINT.signUpPopUp[targetDrive]

    store.userStore.doSendGAEvent(params)
  }
  signUpSuccessful() {
    const targetDrive = this.getTargetDrive()

    if (targetDrive === null) {
      return
    }

    const params = GA_FOR_SHAREPOINT.signUpSuccessful[targetDrive]

    store.userStore.doSendGAEvent(params)
  }
  signUpFailed() {
    const targetDrive = this.getTargetDrive()

    if (targetDrive === null) {
      return
    }

    const params = GA_FOR_SHAREPOINT.signUpFailed[targetDrive]

    store.userStore.doSendGAEvent(params)
  }
  yearlyFreeTrial() {
    const targetDrive = this.getTargetDrive()

    if (targetDrive === null) {
      return
    }

    const params = GA_FOR_SHAREPOINT.yearlyFreeTrial[targetDrive]

    store.userStore.doSendGAEvent(params)
  }
  yearlyFreeTrialSuccessful() {
    const targetDrive = this.getTargetDrive()

    if (targetDrive === null) {
      return
    }

    const params = GA_FOR_SHAREPOINT.yearlyFreeTrialSuccessful[targetDrive]

    store.userStore.doSendGAEvent(params)
  }
  yearlyFreeTrialFailed() {
    const targetDrive = this.getTargetDrive()

    if (targetDrive === null) {
      return
    }

    const params = GA_FOR_SHAREPOINT.yearlyFreeTrialFailed[targetDrive]

    store.userStore.doSendGAEvent(params)
  }
  monthlyFreeTrial() {
    const targetDrive = this.getTargetDrive()

    if (targetDrive === null) {
      return
    }

    const params = GA_FOR_SHAREPOINT.monthlyFreeTrial[targetDrive]

    store.userStore.doSendGAEvent(params)
  }
  monthlyFreeTrialSuccessful() {
    const targetDrive = this.getTargetDrive()

    if (targetDrive === null) {
      return
    }

    const params = GA_FOR_SHAREPOINT.monthlyFreeTrialSuccessful[targetDrive]

    store.userStore.doSendGAEvent(params)
  }
  monthlyFreeTrialFailed() {
    const targetDrive = this.getTargetDrive()

    if (targetDrive === null) {
      return
    }

    const params = GA_FOR_SHAREPOINT.monthlyFreeTrialFailed[targetDrive]

    store.userStore.doSendGAEvent(params)
  }
}